export const stats: [string, string][] = [
  ['6', 'NIVEAUX COMPLETS'],
  ['360', 'PAGES DE CONTENU'],
  ['144', 'EXERCICES CLASSÉS PAR NIVEAU'],
  ['100%', "PRÊT À L'EMPLOI"],
]
